import { Box, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import MallScanner from "src/components/shared/ScanningInput";
import useAppGlobal from "src/context/useAppGlobal";
import useOrderByCode from "src/hooks/orders/useOrderByCode";
import PrepareBulkOrderScan from "./PrepareBulkOrderScan";

export default function PrepareBulkOrder({ warehouseId, mutate }) {
  const { handleOpenDialog } = useAppGlobal();
  const [orderId, setOrderId] = useState();

  const { data: order, isLoading } = useOrderByCode({ warehouse: warehouseId, code: orderId });

  const handleOpenOrder = () => {
    handleOpenDialog({
      title: "Soạn hàng",
      size: "md",
      content: <PrepareBulkOrderScan order={order} mutate={mutate} />,
    });
  };

  useEffect(() => {
    if (order?.data) {
      handleOpenOrder();
    }
  }, [order?.data]);

  return (
    <Stack
      alignItems="center"
      spacing={2}
      py={6}
    >
      <Box sx={{ width: "60%", mx: "auto" }}>
        <MallScanner
          getIndividualValue={setOrderId}
          individualValue={orderId}
          label="Scan mã vận đơn / mã đơn hàng"
          disabled={isLoading}
        />
      </Box>
    </Stack>
  );
}
